import { soldProducts } from "./sold-products";
import { chipsBurned } from "./chips-burned";
import { paymentMethodReport } from "./payment-method-report";

export const barReports = {
	tabs: {
		soldProducts,
		chipsBurned,
		waiterReport: {
			label: "Ranking de Ventas",
			filter: "Filtrar por tipo de transacción",
		},
		deliveredProductsByBar: {
			label: "Productos entregados por bar",
		},
		consolidatedBarReport: {
			label: "Financiero por bar",
			tab: "Facturación por bar",
			filter: "Filtrar por tipo de transacción",
			total: "Total",
			sheet: {
				title: "Facturación por bar",
				fileName: "facturacion-por-bar",
				name: "Producto",
				quantity: "Cantidad",
				totalValue: "Valor bruto",
				totalDiscount: "Descuento total",
				value: "Valor neto",
				totalTax: "Impuesto Total",
				vat: {
					totalValue: "Valor con IVA",
					valueWithDiscount: "Valor con descuento",
					value: "Valor sin IVA",
					totalTax: "Valor del IVA",
					totalTaxPercentage: "Porcentaje total del IVA (%)",
				},
			},
			paymentMethodReport,
		},
		soldProductReport: {
			label: "Salida general de productos",
			filter: "Filtrar por tipo de transacción",
			sheet: {
				title: "Salida general de productos",
				fileName: "reporte_de_salida_general_de_productos",
				fiscalCode: "SKU",
				name: "Producto",
				count: "Cantidad",
			},
		},
		reprintReport: {
			title: "Reimpresión de fichas",
			filename: "reimpresion-de-fichas",
			byTransaction: "Por transacción",
			byProduct: "Por producto",
			variable: "Variable",
			variableTooltip:
				"El valor unitario de productos con valor variable es el promedio de los valores vendidos",
			table: {
				authorizedBy: "Empleado autorizador",
				date: "Fecha/hora",
				employee: "Empleado conectado",
				transactionId: "ID de transacción",
				device: "Máquina",
				product: "Producto",
				total: "Total",
				reprintTotal: "Total en reimpresiones",
				reprintProductTotal: "Total de productos reimpresos",
				authorizedByPassword: "Autorizado por contraseña",
				quantity: "Cantidad",
				productName: "Nombre del producto",
				unitValue: "Valor unitario",
				value: "Valor",
			},
			tooltipTitle:
				"Este informe solo traerá datos si los PDV están en la versión 5.0.190 o superior.",
		},
	},
	bar: "Bar {{name}}",
	undefinedBar: "Bar Indefinido",
	productReturnsReport: {
		title: "Devolución de producto",
	},
};
